export default __webpack_public_path__ + "static/media/869.07092cf8.gif";